export const generateLocUrl = (id: string) => {
    return encodeURI(`${window.origin}?lokid=${id}`)
}